var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4166 18.5417C13.2911 18.5417 14 17.8328 14 16.9583C14 16.0839 13.2911 15.375 12.4166 15.375C11.5422 15.375 10.8333 16.0839 10.8333 16.9583C10.8333 17.8328 11.5422 18.5417 12.4166 18.5417Z",
    fill: "#3E3D3D",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1471 10.2059H17.8C17.8733 9.84479 17.9118 9.47101 17.9118 9.08823C17.9118 6.00194 15.4099 3.5 12.3236 3.5C9.82611 3.5 7.71132 5.13829 6.99524 7.39881L7.86963 7.98173C8.36473 5.98225 10.171 4.5 12.3236 4.5C14.8576 4.5 16.9118 6.55422 16.9118 9.08823C16.9118 9.47375 16.8642 9.84817 16.7747 10.2059H6.5C5.39543 10.2059 4.5 11.1014 4.5 12.2059V20.5C4.5 21.6046 5.39543 22.5 6.5 22.5H18.1471C19.2516 22.5 20.1471 21.6046 20.1471 20.5001V12.2059C20.1471 11.1014 19.2516 10.2059 18.1471 10.2059ZM18.1471 11.2059H6.5C5.94771 11.2059 5.5 11.6536 5.5 12.2059V20.5C5.5 21.0523 5.94771 21.5 6.5 21.5H18.1471C18.6993 21.5 19.1471 21.0523 19.1471 20.5001V12.2059C19.1471 11.6536 18.6993 11.2059 18.1471 11.2059Z",
    fill: "#3E3D3D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/changePasswordIcon.9563af09d3f43732d21f2335e2dd1fed.svg";
export { ForwardRef as ReactComponent };